<script>
  export let value;
  export let lang = undefined;
</script>

<a href={value.link} class='link'>
  <div class='link-box'>
    <img class='link-box-logo' src='img/static/logo/{value.logo}.svg' alt='{value.label.en} logo'/>

    <div class='link-box-label'>
      <div class='link-box-label-text'> {value.label[lang]} </div>
    </div>
  </div>
</a>

<style>
  .link {
    flex-grow: 1;

    width: 100%;

    text-decoration: none;

    color: inherit;
  }

  .link-box {
    display: flex;
    gap: 15px;

    padding: 15px;

    border-radius: var(--radius-lg);

    background: var(--grey-3);

    transition: box-shadow 1s ease-in-out, transform 1s ease-in-out;
  }

  .link-box:hover {
    box-shadow: 0px 0px 10px 0px var(--grey-5);

    transform: scale(1.025);
  }

  .link-box-logo {
    flex-shrink: 0;

    width: 100px;
    height: 50px;

    object-fit: contain;
  }

  .link-box-label {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 50px;

    font-weight: 550;
  }

  .link-box-label-text {
    text-align: center;
  }

  :global(body.dark) .link-box {
    background: var(--grey-7);
    color: var(--black);
  }

  :global(body.dark) .link-box:hover {
    box-shadow: 0px 0px 10px 0px var(--grey-9);
  }

  :global(body.dark) .link-box-logo {
    filter: brightness(88%);
  }

  @media only screen and (max-width: 1300px) {
    .link {
      width: calc((100% - 40px) / 3);
    }
  }

  @media only screen and (max-width: 1100px) {
    .link {
      width: calc((100% - 20px) / 2);
    }
  }

  @media only screen and (max-width: 750px) {
    .link {
      width: 100%;
    }
  }

  @media only screen and (max-width: 450px) {
    .link-box-logo {
      width: 80px;
      height: 40px;
    }

    .link-box-label {
      height: 40px;
    }
  }

  @media only screen and (max-width: 400px) {
    .link-box-label {
      font-size: 14px;
    }
  }
</style>
